/*
 * @ Author: wangjiyu
 * @Date: 2020-04-07 11:49:22
 * @LastEditTime: 2025-03-13 09:51:09
 * @LastEditors: liuzhenxing liuzhenxing@lixiang.com
 * @Description: file content
 */
enum ActionType {
    PostSetCover,
    PostSetTitle,
    PostValidAtMax,
    PostValidAtMin,
    PostSetProductId,
    PostSetTopic,
    PostSetLocation,
    PostSetMusic,
    PostDeleteMusic,
    PostSetHasPlay,
    PostSetContent,
    setVoteListTop,
    setVoteListBottom,
    PostSetContentByIndex,
    PostInsertContentByIndex,
    PostRemoveContentByIndex,
    PostSetCurrentInputIndex,
    PostSetCurrentIndex,
    PostSetCurrentTarget,
    PostSetHasFocusTitle,
    PostSetMainScrollTop,
    PostInsertTitleByIndex,
    PostEditTitleByIndex,
    setKeyboradHeight,
    setEmojiVisible,
    setEmojiBoxHeight,
    setEmptyViewHeight,
    setSelectionEnd,
    setHasInputEmoji,
    setMaxFile,
    setMaxVideo,
    setControlIconActive,
    PostSetCoverPixel,
    PostGroupId,
}

export default ActionType;
